import React from 'react'
import PropTypes from 'prop-types'

export const METable = props => {
  let columnCss = props.columnCss ? props.columnCss : {}
  return (
    <div className="d-block mt-2 mb-4" style={{ overflowX: 'auto' }}>
      <table className="table table-striped table-hover table-condensed">
        <thead>
          <tr>
            {props.columns.map((col, i) => (
              <th
                key={i}
                className={columnCss[col] !== undefined ? columnCss[col] : null}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data.map((row, i) => (
            <tr key={`${i}`}>
              {row.map((cell, j) => (
                <td key={`${i}_${j}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

METable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
}
